import { State } from 'src/types'
import { thumbHook } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/thumbHook'
import { littleHook } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/littleHook'
import { laceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/lace'
import { liningDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/liningDrawer'
import { backStyleDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/backStyleDrawer'
import { atomsLabelDrawerForCatcherMitt } from 'src/features/brands/atoms/canvas/common/useCanvasHelper'
import { canvasResetter } from 'src/features/brands/atoms/canvas/common/canvasResetter'
import { catchFaceDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/catchFaceDrawer'
import { webDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/webDrawer'
import { fingerEmbroideryDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/fingerEmbroideryDrawer'
import { fingerGuardDrawer } from 'src/features/brands/atoms/canvas/rightThrow/catchermitt/back/fingerGuardDrawer'

export const atomsCanvasCatcherMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  canvasResetter(ctx) // リセット
  liningDrawer(ctx, state) // 裏革
  backStyleDrawer(ctx, state) // バックスタイル
  catchFaceDrawer(ctx, state.catchFace.color, state.stitch.color, state.baseModel.productNumber) // 捕球面側
  fingerGuardDrawer(ctx, state) // 指カバー・指当て
  fingerEmbroideryDrawer(ctx, state.embroideries) // 親指、小指の刺繍
  webDrawer(ctx, state) // ウェブ
  laceDrawer(ctx, state.lace.color) // 革紐
  thumbHook(ctx, state.thumbHook.color) // かけ紐
  littleHook(ctx, state.littleHook.color) // かけ紐
  atomsLabelDrawerForCatcherMitt(ctx, state) // ブランドのラベル
}

const embroideryState = {
  id: 0,
  typeFace: { label: '漢字', value: 'serif' },
  position: { label: '親指部分', value: 'thumbFinger' },
  color: { label: 'ホワイト', value: 'white', color: '#F6F3F0' },
  shadowColor: { label: '不要', value: 'none' },
  edgeColor: { label: '不要', value: 'none' },
  content: ''
}
